module.exports = __webpack_public_path__ + "static/media/ST6.ae6cec38.jpg";